import React from 'react';

/**
 * SkipLink component for keyboard accessibility
 * Allows keyboard users to bypass navigation and jump directly to main content
 * Only visible when focused via keyboard (Tab key)
 *
 * WCAG 2.1 Level A - Success Criterion 2.4.1: Bypass Blocks
 */
const SkipLink = () => (
  <a
    href="#main-content"
    className="bg-gray-100 text-black px-4 py-2 text-sm rounded focus:left-0 focus:top-0 absolute font-semibold no-underline"
    style={{
      left: '-9999px',
      zIndex: 999,
    }}
    onFocus={(e) => {
      e.target.style.left = '0';
      e.target.style.top = '0';
    }}
    onBlur={(e) => {
      e.target.style.left = '-9999px';
    }}
  >
    Skip to main content
  </a>
);

export default SkipLink;
